import { render } from "./ModalAgreement.vue?vue&type=template&id=4b03c41f&scoped=true"
import script from "./ModalAgreement.vue?vue&type=script&lang=js"
export * from "./ModalAgreement.vue?vue&type=script&lang=js"

import "./ModalAgreement.vue?vue&type=style&index=0&id=4b03c41f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b03c41f"]])

export default __exports__